import { createContext } from "react";

export const ConditionQuestionsContext = createContext(null);
